import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth'
import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage'

/**
 * Public forgot-password route (Story E02.03).
 *
 * Telegram-mediated flow per FR-AUTH-05 + C-16: the user submits a
 * username, the backend records the request, and an admin reaches out
 * via Telegram with a temporary password. The fronted does not surface
 * any reset link — it only confirms the request was accepted.
 *
 *   - AC-02 preflight-redirect: an already-authenticated visitor is
 *     redirected to `/dashboard` from `beforeLoad` (parity with `/login`
 *     and `/register`). Throwing the redirect from `beforeLoad` prevents
 *     the form from mounting at all.
 */
export const Route = createFileRoute('/forgot-password')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: ForgotPasswordRouteComponent,
})

function ForgotPasswordRouteComponent() {
  return <ForgotPasswordPage />
}
